import React, { useState } from 'react';
import useFetchData from '../../../../hooks/useFetchData';
import GeneralComponentErrorShield from '../../../general/GeneralComponentErrorShield';
import AssetAllocationPerformanceTable from './subComponents/AssetAllocationPerformanceTable.component';
import {
  activeDateRangeEndSelector,
  activeDateRangeStartSelector,
} from '../../../../redux/pages/selectors';
import { useSelector } from 'react-redux';
import AssetAllocationPerformanceChart from './subComponents/AssetAllocationPerformanceChart.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';

const AssetAllocationPerformance: React.FC<FundInfoComponentProps> = ({
  fundId,
}) => {
  const fromDate = useSelector(activeDateRangeStartSelector);
  const toDate = useSelector(activeDateRangeEndSelector);

  const PerformanceAttributionData = useFetchData({
    url: `/performance_attribution/${fundId}/${fromDate}/${toDate}`,
    keyName: `performance_attribution_${fundId}_${fromDate}_${toDate}`,
    makeFetch:
      fundId !== undefined &&
      fromDate !== null &&
      fromDate !== '' &&
      toDate !== null &&
      toDate !== '',
  });

  const [benchmark] = useState<string>('MSCI World Index');

  return (
    <GeneralComponentErrorShield
      dataObjects={[PerformanceAttributionData]}
      customLoadingMessages={[
        'Loading Performance Attribution Data',
        `${fromDate} to ${toDate}`,
        'Just a few more seconds...',
      ]}
      customErrorMessage="No Data Available."
    >
      <AssetAllocationPerformanceChart
        data={PerformanceAttributionData}
        benchmark={benchmark}
      />
      <AssetAllocationPerformanceTable data={PerformanceAttributionData} />
    </GeneralComponentErrorShield>
  );
};

export default AssetAllocationPerformance;
